var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraIconBackgroundTurquoise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "#00B0CA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7218 14.6943H16.0933C17.028 14.6943 17.8974 14.2148 18.3959 13.4241L19.3649 11.8854C19.8634 11.0947 20.7328 10.6151 21.6675 10.6152H24.8284C25.7631 10.6151 26.6325 11.0947 27.131 11.8854L28.0999 13.4241C28.5984 14.2148 29.4678 14.6943 30.4025 14.6943H32.7741C34.2773 14.6943 35.4959 15.9128 35.4959 17.416V29.5587C35.4919 31.1184 34.2285 32.3817 32.6689 32.3857H13.827C12.2673 32.3817 11.004 31.1184 11 29.5587V17.416C11 15.9128 12.2186 14.6943 13.7218 14.6943Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2496 26.9424C25.5044 26.9424 27.3323 25.1145 27.3323 22.8597C27.3323 20.605 25.5044 18.7771 23.2496 18.7771C20.9949 18.7771 19.167 20.605 19.167 22.8597C19.167 25.1145 20.9949 26.9424 23.2496 26.9424Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraIconBackgroundTurquoise);
export default __webpack_public_path__ + "static/media/camera-icon-background-turquoise.adacb928ab020c345229b640ffa6f783.svg";
export { ForwardRef as ReactComponent };